import { ApplicationState } from "../index";

export function getById(id: string) {
  console.log(":id query", id)
  return (state: ApplicationState) =>
    state.merchantStaging.data?.data?.find((x) => x.id === id);
}
